<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"><CIcon :name="icon" size="lg"/> {{ caption }}</span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>

          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
export default {
  name: 'UserDashborad',
  props: {
    caption: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "cil-layers"
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {

      item : [
        {author :"Abhi Sharma", date : "12/15/2014", state : "Shift Created", complete: true},
        {author :"PAM Admin", date : "12/15/2014", state : "Email Sent", complete: true},
        {author :"Aaron Rodgers", date : "12/15/2014", state : "SIC Approval", complete: true},
        {author :"PAM Admin", date : "PAM Admin", state : "Shift Completed", complete: false},
      ]
    }

  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },





  },



  computed:{
    ...mapGetters({
      lang : "setting/lang",

    }),
  },

  watch: {

  }

}
</script>
<style >

</style>


